import type {ReactAction} from '@netx/core/bootstrap';
import {faCalendarPlus} from '@fortawesome/pro-solid-svg-icons';
import {canManageCurrentCartExpiration} from '../enablers';
import {CART_CURRENT_ACTION_LABELS} from '../locales';
import {CART_CURRENT_EVENT} from './constants';

/**
 * Set cart asset expiration
 * @param params
 * @returns Action
 */
export const cartActionManageExpirationSet = (
	params: Partial<ReactAction> = {},
): ReactAction => ({
	name: 'cart-current-manage-expiration-set',
	cb: () => dispatcher.trigger(CART_CURRENT_EVENT.MANAGE_EXPIRATION_SET),
	enableTest: canManageCurrentCartExpiration,
	icon: faCalendarPlus,
	get label() {
		return CART_CURRENT_ACTION_LABELS.MANAGE_EXPIRATION_SET;
	},
	...params,
});

export default cartActionManageExpirationSet;
